// src/pages/Dashboard.js — v2
// Shows individual order blocks + "Add Items" button navigating to Billing

import React, { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom';

const STATUS_COLOR = { Preparing:'tag-red', Ready:'tag-amber', Delivered:'tag-green' };

export default function Dashboard() {
  const [bills, setBills] = useState([]);
  const [inv, setInv] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const start = new Date(); start.setHours(0,0,0,0);
    const q1 = query(collection(db,'bills'), where('createdAt','>=',Timestamp.fromDate(start)));
    const u1 = onSnapshot(q1, s => setBills(s.docs.map(d=>({id:d.id,...d.data()})).sort((a,b)=>(b.createdAt?.toMillis?.()||0)-(a.createdAt?.toMillis?.()||0))));
    const u2 = onSnapshot(collection(db,'inventory'), s => setInv(s.docs.map(d=>({id:d.id,...d.data()}))));
    return () => { u1(); u2(); };
  }, []);

  const revenue = bills.reduce((a,b)=>a+(b.total||0),0);
  const lowItems = inv.filter(m=>m.stock<=m.reorderLevel);

  return (
    <div>
      <div className="grid4">
        {[['Today Revenue','₹'+revenue.toLocaleString()],['Orders Today',bills.length],['Avg Order Value','₹'+Math.round(revenue/Math.max(bills.length,1))],['Low Stock Alerts',lowItems.length]].map(([l,v],i)=>(
          <div key={l} className="metric"><div className="metric-label">{l}</div><div className="metric-val" style={i===3&&+v>0?{color:'#e53935'}:{}}>{v}</div></div>
        ))}
      </div>

      <div className="card">
        <div className="sec-title">Today's Orders</div>
        {!bills.length && <div style={{ color:'#bbb', fontSize:13, textAlign:'center', padding:30 }}>No orders yet today</div>}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:10 }}>
          {bills.map(b => (
            <div key={b.id} style={{ border:'1px solid #eee', borderRadius:10, padding:'11px 13px' }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
                <span style={{ fontWeight:600, fontSize:13 }}>{b.billNo || b.id.slice(0,6)}</span>
                <span className={`tag ${STATUS_COLOR[b.status||'Preparing']}`}>{b.status||'Preparing'}</span>
              </div>
              <div style={{ fontSize:12, color:'#888', marginBottom:4 }}>
                {b.orderType==='dinein' ? `Table ${b.table}` : (b.orderType==='takeout' ? 'Takeout' : 'Delivery')}
              </div>
              <div style={{ fontSize:12, color:'#666', marginBottom:8, maxHeight:40, overflow:'hidden' }}>
                {(b.items||[]).map(i=>i.name).join(', ')}
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span style={{ fontWeight:700 }}>₹{b.total}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="grid2" style={{ marginTop:16 }}>
        <div className="card">
          <div className="sec-title">Stock status</div>
          {inv.slice(0,8).map(m=>{
            const low=m.stock<=m.reorderLevel;
            const pct=Math.min(100,Math.round((m.stock/Math.max(m.reorderLevel*2.5,.01))*100));
            return (<div key={m.id} style={{ marginBottom:8 }}>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, marginBottom:2 }}>
                <span>{m.name}</span><span style={{ color:low?'#e53935':'#888' }}>{+m.stock.toFixed(2)} {m.unit}</span>
              </div>
              <div style={{ height:5, borderRadius:3, background:'#f0f0f0', overflow:'hidden' }}>
                <div style={{ height:'100%', borderRadius:3, width:pct+'%', background:low?'#e53935':'#1D9E75' }} />
              </div>
            </div>);
          })}
        </div>
        <div className="card">
          <div className="sec-title">Quick Actions</div>
          <button className="btn btn-primary" style={{ width:'100%', marginBottom:8 }} onClick={()=>navigate('/billing')}>🧾 New Bill</button>
          <button className="btn" style={{ width:'100%' }} onClick={()=>navigate('/reports')}>📈 View Reports</button>
        </div>
      </div>
    </div>
  );
}